export default "__VITE_ASSET__8931c9b5__"